module.exports = __webpack_public_path__ + "assets/img/media-music-layer-1-81fb72dc.png";